export default {
  // 已有文本
  'pages.dashboard.text': '無縫接入門店管理生態，提供遠程積分管理解決方案。',
  'pages.dashboard.storeTitle': '門店',
  'pages.dashboard.management.title': '總部管理',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': '顯示會員註冊二維碼',
  'pages.dashboard.qrcode.title': '會員註冊二維碼',
  'pages.dashboard.qrcode.download': '下載二維碼',
  'pages.dashboard.qrcode.close': '關閉',

  // 其他已有文本
  'pages.dashboard.tooltip.members': '會員管理',
  'pages.dashboard.tooltip.cards': '禮品卡',
  'pages.dashboard.tooltip.coupons': '優惠券',
  'pages.dashboard.tooltip.orders': '訂單',

  'pages.dashboard.userApp.management.title': '用戶 App 管理',
  'pages.dashboard.userApp.posters.button': '內容管理',
  'pages.dashboard.userApp.posters.title': '內容管理',
  'pages.dashboard.userApp.posters.add': '新增海報',
  'pages.dashboard.userApp.posters.edit': '編輯海報',
  'pages.dashboard.userApp.posters.noPermission.title': '無權限',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    '你無權訪問該總部的用戶 App 宣傳海報管理。',
  'pages.dashboard.userApp.posters.upload.imageTypeError': '只能上傳 jpg、png 或 webp 圖片',
  'pages.dashboard.userApp.posters.upload.sizeError': '圖片不能超過 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': '請上傳海報圖片',
  'pages.dashboard.userApp.posters.message.saveSuccess': '保存成功',
  'pages.dashboard.userApp.posters.message.deleteSuccess': '刪除成功',
  'pages.dashboard.userApp.posters.empty.all': '暫無海報',
  'pages.dashboard.userApp.posters.empty.carousel': '暫無頂部滾動海報',
  'pages.dashboard.userApp.posters.empty.static': '暫無靜態海報',
  'pages.dashboard.userApp.posters.delete.confirm': '確認刪除這張海報？',
  'pages.dashboard.userApp.posters.delete.ok': '刪除',
  'pages.dashboard.userApp.posters.delete.cancel': '取消',
  'pages.dashboard.userApp.posters.type.carousel': '滾動翻頁海報',
  'pages.dashboard.userApp.posters.type.static': '靜態海報',
  'pages.dashboard.userApp.posters.sort': '排序',
  'pages.dashboard.userApp.posters.section.carousel': '頂部滾動海報',
  'pages.dashboard.userApp.posters.section.static': '靜態海報',
  'pages.dashboard.userApp.posters.form.title': '海報標題',
  'pages.dashboard.userApp.posters.form.title.required': '請輸入海報標題',
  'pages.dashboard.userApp.posters.form.title.placeholder': '例如：週末狂歡購',
  'pages.dashboard.userApp.posters.form.displayType': '海報類型',
  'pages.dashboard.userApp.posters.form.displayType.required': '請選擇海報類型',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    '滾動翻頁海報（頂部自動輪播，建議 1536 x 860）',
  'pages.dashboard.userApp.posters.form.displayType.static':
    '靜態海報（下方列表，建議 1536 x 560）',
  'pages.dashboard.userApp.posters.form.sortOrder': '滾動順序',
  'pages.dashboard.userApp.posters.form.sortOrder.required': '請選擇滾動順序',
  'pages.dashboard.userApp.posters.form.sortOrder.page': '第 {value} 頁',
  'pages.dashboard.userApp.posters.form.image': '海報圖片',
  'pages.dashboard.userApp.posters.form.image.replace': '替換圖片（可選）',
  'pages.dashboard.userApp.posters.form.image.select': '選擇圖片',
  'pages.dashboard.userApp.posters.scope.common': '通用海報',
  'pages.dashboard.userApp.posters.scope.store': '門店海報',
  'pages.dashboard.userApp.posters.store.placeholder': '請選擇門店',
  'pages.dashboard.userApp.posters.store.viewOnly': '僅可查看——需要門店海報管理權限',
  'pages.dashboard.userApp.catalog.tab': '目錄',
  'pages.dashboard.userApp.catalog.current': '目前目錄',
  'pages.dashboard.userApp.catalog.none': '尚未發布目錄',
  'pages.dashboard.userApp.catalog.replace': '替換目錄',
  'pages.dashboard.userApp.catalog.upload': '上傳目錄',
  'pages.dashboard.userApp.catalog.title': '標題',
  'pages.dashboard.userApp.catalog.dates': '展示日期和時間（雪梨時間）',
  'pages.dashboard.userApp.catalog.pdf': 'PDF 檔案',
  'pages.dashboard.userApp.catalog.select': '選擇 PDF',
  'pages.dashboard.userApp.catalog.entryImage': '目錄入口封面圖',
  'pages.dashboard.userApp.catalog.entryImageHint': '建議尺寸：1200 × 360 px。',
  'pages.dashboard.userApp.catalog.selectImage': '選擇圖片',
  'pages.dashboard.userApp.catalog.invalidImage': '請選擇不超過 20 MB 的 JPG、PNG 或 WebP 圖片',
  'pages.dashboard.userApp.catalog.publish': '發布目錄',
  'pages.dashboard.userApp.catalog.replacePublish': '替換並發布',
  'pages.dashboard.userApp.catalog.delete': '刪除',
  'pages.dashboard.userApp.catalog.confirm': '確認刪除該目錄？',
  'pages.dashboard.userApp.catalog.open': '開啟 PDF',
  'pages.dashboard.userApp.catalog.pages': '{count} 頁',
  'pages.dashboard.userApp.catalog.processing': '正在處理目錄 {done} / {total} 頁',
  'pages.dashboard.userApp.catalog.failed': '處理失敗：{error}',
  'pages.dashboard.userApp.catalog.issues': '已排期目錄',
  'pages.dashboard.userApp.catalog.active': '展示中',
  'pages.dashboard.userApp.catalog.edit': '編輯',
  'pages.dashboard.userApp.catalog.save': '儲存',
  'pages.dashboard.userApp.catalog.saved': '目錄已儲存',
  'pages.dashboard.userApp.catalog.removed': '目錄已刪除',
  'pages.dashboard.userApp.catalog.queued': '目錄正在處理',
  'pages.dashboard.userApp.catalog.required': '請填寫標題並選擇 PDF 和封面圖',
  'pages.dashboard.userApp.catalog.invalidPeriod': '請選擇有效的開始和結束日期時間',
  'pages.dashboard.userApp.catalog.invalidPdf': '請選擇不超過 30 MB 的 PDF',
  'pages.dashboard.userApp.catalog.loadFailed': '無法載入目錄',
  'pages.dashboard.userApp.catalog.uploadFailed': '目錄上傳失敗',
  'pages.dashboard.userApp.catalog.saveFailed': '無法儲存目錄',
  'pages.dashboard.userApp.catalog.removeFailed': '無法移除目錄',
  'pages.dashboard.userApp.catalog.libraryTab': 'Catalog 庫',
  'pages.dashboard.userApp.catalog.libraryHint': '所有門店共用。在「首頁佈局」中把 Catalog 加入佈局。',
  'pages.dashboard.userApp.catalog.moveUp': '上移',
  'pages.dashboard.userApp.catalog.moveDown': '下移',
  'pages.dashboard.userApp.catalog.status.live': '展示中',
  'pages.dashboard.userApp.catalog.status.scheduled': '未開始',
  'pages.dashboard.userApp.catalog.status.ended': '已結束',
  'pages.dashboard.userApp.layout.tab': '首頁佈局',
  'pages.dashboard.userApp.layout.loadFailed': '無法載入首頁佈局',
  'pages.dashboard.userApp.layout.discardConfirm': '放棄未儲存的佈局修改？',
  'pages.dashboard.userApp.layout.discard': '放棄修改',
  'pages.dashboard.userApp.layout.keepEditing': '繼續編輯',
  'pages.dashboard.userApp.layout.saved': '佈局已發佈到 App',
  'pages.dashboard.userApp.layout.saveFailed': '佈局發佈失敗',
  'pages.dashboard.userApp.layout.pickCatalog': '請選擇 Catalog',
  'pages.dashboard.userApp.layout.needImage': '請至少新增一張圖片',
  'pages.dashboard.userApp.layout.invalidImage': '請選擇 5 MB 以內的 JPG、PNG 或 WebP 圖片',
  'pages.dashboard.userApp.layout.uploadFailed': '圖片上傳失敗',
  'pages.dashboard.userApp.layout.type.carousel': '輪播',
  'pages.dashboard.userApp.layout.type.poster': '海報',
  'pages.dashboard.userApp.layout.type.catalog': 'Catalog',
  'pages.dashboard.userApp.layout.catalogMissing': '找不到該 Catalog',
  'pages.dashboard.userApp.layout.carouselMeta': '{count}/{max} 張圖片 · 每 {seconds} 秒自動切換',
  'pages.dashboard.userApp.layout.posterMeta': '單張圖片 · 全寬',
  'pages.dashboard.userApp.layout.previewHeader': '首頁',
  'pages.dashboard.userApp.layout.previewEmpty': '暫無內容',
  'pages.dashboard.userApp.layout.dragHandle': '拖動排序',
  'pages.dashboard.userApp.layout.status.live': '展示中',
  'pages.dashboard.userApp.layout.status.scheduled': '未開始',
  'pages.dashboard.userApp.layout.status.ended': '已結束',
  'pages.dashboard.userApp.layout.moveUp': '上移',
  'pages.dashboard.userApp.layout.moveDown': '下移',
  'pages.dashboard.userApp.layout.hide': '在 App 中隱藏',
  'pages.dashboard.userApp.layout.show': '在 App 中顯示',
  'pages.dashboard.userApp.layout.edit': '編輯',
  'pages.dashboard.userApp.layout.removeConfirm': '從佈局中移除這個區塊？',
  'pages.dashboard.userApp.layout.remove': '移除',
  'pages.dashboard.userApp.layout.catalog': 'Catalog',
  'pages.dashboard.userApp.layout.noCatalogs': '請先在 Catalog 庫上傳 Catalog',
  'pages.dashboard.userApp.layout.blockName': '區塊名稱',
  'pages.dashboard.userApp.layout.blockNameHint': '僅在後台顯示。',
  'pages.dashboard.userApp.layout.interval': '自動切換間隔',
  'pages.dashboard.userApp.layout.seconds': '{seconds} 秒',
  'pages.dashboard.userApp.layout.imagesCount': '圖片（{count}/{max}）',
  'pages.dashboard.userApp.layout.image': '圖片',
  'pages.dashboard.userApp.layout.slide': '第 {index} 張',
  'pages.dashboard.userApp.layout.replaceImage': '點擊或拖入圖片進行替換',
  'pages.dashboard.userApp.layout.uploadImages': '點擊或拖入圖片新增',
  'pages.dashboard.userApp.layout.carouselImageHint': '建議 1536 × 860，JPG、PNG 或 WebP，5 MB 以內。',
  'pages.dashboard.userApp.layout.posterImageHint': '建議 1536 × 560，JPG、PNG 或 WebP，5 MB 以內。',
  'pages.dashboard.userApp.layout.layoutFor': '佈局範圍',
  'pages.dashboard.userApp.layout.scope.common': '通用（所有門店）',
  'pages.dashboard.userApp.layout.scope.store': '門店佈局',
  'pages.dashboard.userApp.layout.storePlaceholder': '選擇門店',
  'pages.dashboard.userApp.layout.useCommon': '使用通用佈局',
  'pages.dashboard.userApp.layout.viewOnly': '僅查看',
  'pages.dashboard.userApp.layout.lastPublished': '上次發佈：{time}，{user}',
  'pages.dashboard.userApp.layout.unsaved': '有未儲存的修改',
  'pages.dashboard.userApp.layout.publish': '儲存並發佈',
  'pages.dashboard.userApp.layout.usingCommon': '該門店正在使用通用佈局。取消勾選「使用通用佈局」即可為該門店單獨設定。',
  'pages.dashboard.userApp.layout.blocksTitle': '首頁內容區塊',
  'pages.dashboard.userApp.layout.blocksHint': '共 {count} 個 · 拖動把手或點箭頭調整順序',
  'pages.dashboard.userApp.layout.preview': 'App 預覽',
  'pages.dashboard.userApp.layout.previewHint': '隱藏的區塊和不在展示時段內的 Catalog 不會顯示。',
  'pages.dashboard.userApp.layout.addBlock': '新增區塊',
  'pages.dashboard.userApp.layout.editBlock': '編輯區塊',
  'pages.dashboard.userApp.layout.cancel': '取消',
  'pages.dashboard.userApp.layout.done': '完成',
  'pages.dashboard.userApp.layout.empty': '還沒有內容區塊，請新增輪播、海報或 Catalog。',
};
